import React, { useState, useEffect } from 'react';
import {
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonLabel,
    IonInput,
    IonButton,
    IonRow,
    IonCol,
    IonFooter,
    useIonAlert,
    IonSelect,
    IonSelectOption, IonIcon
} from '@ionic/react';

import { actionToAddUser, actionToUpdateUser } from "../apiHelpers/CommonAction";
import {star} from "ionicons/icons";

export default function AddEditUserModal({ isOpen, onClose, setIsLoading, dataForEditing,reloadUserData }) {
    const [form, setForm] = useState({
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        mobile: '',
        designation: 'ca_member',
        dynamicField: '',
        refNo: ''
    });

    const [errors, setErrors] = useState({});
    const [presentAlert] = useIonAlert();

    // Pre-fill form for edit
    useEffect(() => {
        if (dataForEditing?.id) {
            setForm({
                name: dataForEditing.name || '',
                email: dataForEditing.email || '',
                password: '',
                confirmPassword: '',
                mobile: dataForEditing.phone_number || '',
                designation: dataForEditing.designation || 'ca_member',
                dynamicField: dataForEditing?.identity_id || '',
                refNo: dataForEditing.ref_no || ''
            });
        }
    }, [dataForEditing]);

    const handleChange = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
    };

    const getDynamicLabel = () => {
        switch (form.designation) {
            case 'ca_member': return 'ICAI Membership No';
            case 'ca_student': return 'ICAI Student Regn. No';
            case 'other_professional': return 'ICSI / ICMA / Bar Council Membership No';
            case 'accountant_other': return 'PAN No';
            default: return '';
        }
    };

    const validate = () => {
        const err = {};
        if (!form.name.trim()) err.name = 'Name is required';
        if (!form.email.match(/^\S+@\S+\.\S+$/)) err.email = 'Valid email required';
        if (!dataForEditing?.id) {
            if (form.password.length < 8) err.password = 'Password must be at least 8 characters';
            if (form.password !== form.confirmPassword) err.confirmPassword = 'Passwords do not match';
        }
        if (!form.mobile.match(/^\d{10}$/)) err.mobile = 'Enter 10 digit mobile number';
        if (!form.dynamicField.trim()) err.dynamicField = 'This field is required';
        setErrors(err);
        return Object.keys(err).length === 0;
    };

    const handleSubmit = () => {
        if (!validate()) return;
        setIsLoading(true);

        const apiCall = dataForEditing?.id
            ? actionToUpdateUser({userId:dataForEditing?.id,...form,originalEmail:dataForEditing?.email,originalMobile:dataForEditing?.phone_number})
            : actionToAddUser(form);

        apiCall.then((response) => {
                setIsLoading(false);
                if (response?.data?.success) {
                    presentAlert({ message: dataForEditing?.id ? 'User updated successfully.' : 'User added successfully.', buttons: ['OK'] });
                    reloadUserData();
                    onClose();
                } else {
                    presentAlert({ message: response?.data?.message, buttons: ['OK'] });
                }
            })
            .catch(() => {
                setIsLoading(false);
                presentAlert({ message: "Something went wrong.", buttons: ['OK'] });
            });
    };

    return (
        <IonModal isOpen={isOpen} onDidDismiss={onClose} initialBreakpoint={1} breakpoints={[0,1]} handleBehavior="cycle">
            <IonHeader className="job_detail_sheet_header sheet_modal_header">
                <IonToolbar>
                    <IonTitle>{dataForEditing?.id ? 'Edit User' : 'Add User'}</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className="ion-padding bottom-2 no_padding_top">
                <div className="rfp_submit_form">
                    {/* Name */}
                    <div className="rfp_submit_form_item">
                        <IonLabel position="floating">Name<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput className="rfp_form_input" value={form.name} onIonInput={e => handleChange('name', e.detail.value)} />
                        {errors.name && <p className="error-text">{errors.name}</p>}
                    </div>

                    {/* Email */}
                    <div className="rfp_submit_form_item">
                        <IonLabel position="floating">Email<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput className="rfp_form_input" value={form.email} onIonInput={e => handleChange('email', e.detail.value)} />
                        {errors.email && <p className="error-text">{errors.email}</p>}
                    </div>

                    {/* Password & Confirm (Only for Add) */}
                    {!dataForEditing?.id && (
                        <>
                            <div className="rfp_submit_form_item">
                                <IonLabel position="floating">Password<IonIcon icon={star} className="required-star" /></IonLabel>
                                <IonInput className="rfp_form_input" type="password" value={form.password} onIonInput={e => handleChange('password', e.detail.value)} />
                                {errors.password && <p className="error-text">{errors.password}</p>}
                            </div>
                            <div className="rfp_submit_form_item">
                                <IonLabel position="floating">Confirm Password</IonLabel>
                                <IonInput className="rfp_form_input" type="password" value={form.confirmPassword} onIonInput={e => handleChange('confirmPassword', e.detail.value)} />
                                {errors.confirmPassword && <p className="error-text">{errors.confirmPassword}</p>}
                            </div>
                        </>
                    )}

                    {/* Mobile */}
                    <div className="rfp_submit_form_item">
                        <IonLabel position="floating">Mobile<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput className="rfp_form_input" type="tel" value={form.mobile} onIonInput={e => handleChange('mobile', e.detail.value)} />
                        {errors.mobile && <p className="error-text">{errors.mobile}</p>}
                    </div>

                    {/* Ref No */}
                    <div className="rfp_submit_form_item">
                        <IonLabel position="floating">Ref No. (optional)</IonLabel>
                        <IonInput className="rfp_form_input" value={form.refNo} onIonInput={e => handleChange('refNo', e.detail.value)} />
                    </div>

                    {/* Designation */}
                    <div className="rfp_submit_form_item">
                        <IonLabel position="floating">Designation</IonLabel>
                        <IonSelect className="rfp_form_input" value={form.designation} onIonChange={e => handleChange('designation', e.detail.value)}>
                            <IonSelectOption value="ca_member">CA Member</IonSelectOption>
                            <IonSelectOption value="ca_student">CA Student / CA Finalist</IonSelectOption>
                            <IonSelectOption value="other_professional">Other Professional</IonSelectOption>
                            <IonSelectOption value="accountant_other">Accountants / Others</IonSelectOption>
                        </IonSelect>
                    </div>

                    {/* Dynamic Field */}
                    <div className="rfp_submit_form_item">
                        <IonLabel position="floating">{getDynamicLabel()}<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput className="rfp_form_input" value={form.dynamicField} onIonInput={e => handleChange('dynamicField', e.detail.value)} />
                        {errors.dynamicField && <p className="error-text">{errors.dynamicField}</p>}
                    </div>
                </div>
            </IonContent>

            <IonFooter className="ion-padding">
                <IonToolbar>
                <IonRow>
                    <IonCol>
                        <IonButton expand="block" className="close_job_detail_button" color="medium" onClick={onClose}>Close</IonButton>
                    </IonCol>
                    <IonCol>
                        <IonButton expand="block" className="apply_job_button" onClick={handleSubmit}>{dataForEditing?.id ? 'Update' : 'Submit'}</IonButton>
                    </IonCol>
                </IonRow>
                </IonToolbar>
            </IonFooter>
        </IonModal>
    );
}
